import {
    apiRequest,
    salaryP3KDetail
} from "../../../../../services/adapters/master/salaryP3KService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", salaryP3KDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository